const CookieService = {
  Get: (cname: string) => {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  Create: (
    cname: string,
    cvalue: string,
    exdays?: number,
    path?: string,
    samesite?: 'none' | 'strict' | 'lax',
    exminutes?: number,
    exDate?: string,
  ) => {
    var p = path ? path : '/';
    var s = samesite ? samesite : 'none';
    if (exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = d.toUTCString();
    } else if (exminutes) {
      var d = new Date();
      d.setTime(d.getTime() + exminutes * 60000);
      var expires = d.toUTCString();
    } else if (exDate) {
      var expires = exDate;
    } else {
      var expires = 'Thu, 18 Dec 2100 12:00:00 UTC';
    }

    document.cookie = `${cname}=${cvalue}; expires=${expires}; path=${p}; samesite=${s};`;
  },
  Delete: (cname: string) => {
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  },
};

export default CookieService;
